import React from "react";
import config from "./ModuleDefinition";
import EntityForm from "../EntityForm/EntityForm";
import FilterOptionList from "./FilterOption/FilterOptionList";
import FilterOptionForm from "./FilterOption/FilterOptionForm";
import asBookingEngineEntity from "../Common/BookingEngineEntityHOC";
import CONSTANTS from "../constants";
import { withConfig } from "../../../../lib/config";
import { SECTION } from "../../../../lib/constants";

class FilterForm extends React.Component {
  static nestedFomWidgets = {
    /** here is where the nested entity links with the fieldName declared at the module definition, also the corresponding form and list must be imported*/
    filterOptions: asBookingEngineEntity(FilterOptionForm, {
      entityName: CONSTANTS.ENTITY.NESTEDFILTER.name,
      type: "FORM",
      section: SECTION.FILTERS,
    }),
  };

  static nestedListWidgets = {
    filterOptions: asBookingEngineEntity(FilterOptionList, {
      entityName: CONSTANTS.ENTITY.NESTEDFILTER.name,
      type: "LIST",
      section: SECTION.FILTERS,
    }),
  };

  constructor(props, context) {
    super(props, context);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {};
  }

  componentDidMount() {}

  componentWillUnmount() {}

  getFields(fields) {
    return fields && fields.form;
  }

  async handleSubmit({ formValues }) {
    console.log("submitted");
    //TODO: handle case when there's an original entity
    //TODO: this could be handled in a generic way.
    const entity = {
      ...formValues,
    };
    if (
      config.hasOwnProperty("translation") &&
      config.translation &&
      config.translation.hasOwnProperty("entityProperty")
    ) {
      delete entity[config.translation.fieldName];
      const translationField = config.translation.fieldName;
      const translationValues =
        (formValues.hasOwnProperty(translationField) && formValues[translationField]) || [];
      entity[config.translation.entityProperty] = translationValues.map(translation => {
        return {
          locale: translation.locale,
          name: translation.name,
          description: translation.description,
        };
      });
    }

    if (formValues.id) {
      entity.id = formValues.id;
    } else {
      entity.id = null;
    }

    await this.props.onSubmitEntity({
      entity,
    });
  }

  render() {
    const { name, validation, fields, renderers, translation, entities } = config;
    const { locales, entity, entityError, entityResult, loading, getListPath } = this.props;
    const { getFields, handleSubmit } = this;
    return (
      <EntityForm
        loading={loading}
        name={name}
        entity={entity}
        entities={entities}
        validation={validation}
        renderers={renderers}
        fields={getFields(fields)}
        locales={locales}
        translation={translation}
        onSubmit={handleSubmit}
        entityError={entityError}
        entityResult={entityResult}
        getListPath={getListPath}
        nestedFormWidgets={FilterForm.nestedFomWidgets}
        nestedListWidgets={FilterForm.nestedListWidgets}
      />
    );
  }
}

FilterForm.propTypes = {};

FilterForm.defaultProps = {
  locales: ["es", "ca", "en", "fr", "it", "de"],
  entity: {},
};

export default withConfig(FilterForm);
